// @flow
import * as React from 'react';

class ScrollToTopOnMount extends React.PureComponent<{}, {}> {
  componentDidMount(): void {
    window.scrollTo(0, 0);
  }

  render() {
    return null;
  }
}

export default ScrollToTopOnMount;
